var StrategyRedirector = xClass("StrategyRedirector", BaseRedirector)
StrategyConfrim = null;
StrategyRedirector.prototype.getName = function () {
    return "strategy";
}
StrategyRedirector.prototype.hasHighPriorityAction = function() {
    return false;
}
StrategyRedirector.prototype.startStrategy = function(strategyId, levelId){
    require("clover/gamePlay/CreateGameSceneLogic");
    var logic = CreateGameSceneLogic.create(levelId, table()); //攻略不用道具
    logic.startStrategyReplayGamePlayScene(levelId, false, strategyId);
}
StrategyRedirector.prototype.redirect = function () {
    var self = this;
    var param = self.param;

    var um = UserManager.getInstance();
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }
    var levelId = param.levelId;
    if (GameGuideData.getInstance().getRunningGuide()){
        return false;
    }

    if (um.user.topLevelId < levelId){
        Toast.make(getText("leveltip.lowlevel.tip"));
        return true;
    }

    var scene = cc.Director.getInstance().getRunningScene();
    if ((scene && scene.name === "HomeScene") || 
        (scene && scene.name === "GameScene" && scene.logic.levelType === GameLevelType.kMainLevel && (scene.logic.theGamePlayStatus == GamePlayStatus.kFailed || scene.logic.theGamePlayStatus == GamePlayStatus.kWin))) {
        //满足条件看攻略
        return new Promise(resolve => {
            self.showConfirmPanel(resolve);
        });
    } else if (!scene || scene.name === "PreloadScene") {
        
        return false;
    } else {
        Toast.make(getText("leveltip.playing.tip"));
        return false;
    }
}

StrategyRedirector.prototype.showConfirmPanel = function (resolve) {
    var self = this;
    var param = self.param;
    var okCb = function(){
        HomeScenePopoutQueue.getInstance().pause();
        self.startStrategy(param.strategyId, param.levelId);
    }
    var cancelCb = function(){
        resolve();
    }
    function success() {
        if (StrategyConfrim != null){
            StrategyConfrim.onClose();
        }
        var strategyFromShareConfirmPanel = require("clover/panel/StrategyFromShareConfirmPanel");
        StrategyConfrim = strategyFromShareConfirmPanel.create(okCb, cancelCb, param.levelId);
    }
    res = [
		"cocos/commonLib.plist",
		"font/zzgftongxin_40_greenstroke.fnt",
        "packed/StrategyPrompt.pack"
    ]
    preloadWithLoading(res, success, function () {
        Toast.make(getText("error.tip.load_res_error"))
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
    })
}

module.exports = StrategyRedirector